import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Terms.css';
import './Home.css';
import logo from './logo.png';

const Terms: React.FC = () => {
  const navigate = useNavigate();
  const [navOpen, setNavOpen] = React.useState(false);
  React.useEffect(() => {
    document.title = 'Điều khoản sử dụng - Fconnect';
  }, []);
  return (
    <div className="home-page">
      {/* Header (reuse from Home) */}
      <header className="home-header">
        <div className="home-container header-inner">
          <div className="brand" onClick={() => { navigate('/'); setNavOpen(false); } }>
            <img src={logo} alt="Fconnect" />
          </div>
          <button
            className="nav-toggle"
            aria-label={navOpen ? 'Đóng menu' : 'Mở menu'}
            aria-expanded={navOpen}
            aria-controls="main-navigation"
            onClick={() => setNavOpen((o) => !o)}
          >
            {navOpen ? '✕' : '☰'}
          </button>
          <nav id="main-navigation" className={`main-nav ${navOpen ? 'open' : ''}`}>
            <Link to="/" onClick={() => setNavOpen(false)}>Trang chủ</Link>
            <Link to="/lao-dong-pho-thong" onClick={() => setNavOpen(false)}>Lao động phổ thông</Link>
            <Link to="/lao-dong-nong-nghiep" onClick={() => setNavOpen(false)}>Lao động nông nghiệp</Link>
            <Link to="/dich-vu-y-te" onClick={() => setNavOpen(false)}>Dịch vụ y tế</Link>
            <Link to="/privacy" onClick={() => setNavOpen(false)}>Chính sách bảo mật</Link>
            <Link to="/terms" onClick={() => setNavOpen(false)}>Điều khoản</Link>
            <Link to="/contact" onClick={() => setNavOpen(false)}>Liên hệ</Link>
            <Link to="/en" className="lang-link" onClick={() => setNavOpen(false)}>English</Link>
          </nav>
        </div>
      </header>
      <div className={`nav-backdrop ${navOpen ? 'open' : ''}`} onClick={() => setNavOpen(false)} />

      {/* Content */}
      <section className="home-container">
        <header className="terms-header">
          <h1>Điều khoản Sử dụng</h1>
          <p className="last-updated">Cập nhật lần cuối: {new Date().toLocaleDateString('vi-VN')}</p>
        </header>
        <div className="terms-content">
          <section className="terms-section">
            <h2>1. Chấp nhận Điều khoản</h2>
            <p>
              Chào mừng bạn đến với FConnect! Bằng việc truy cập và sử dụng dịch vụ của chúng tôi, 
              bạn đồng ý tuân thủ và bị ràng buộc bởi các điều khoản và điều kiện sau đây. 
              Nếu bạn không đồng ý với bất kỳ phần nào của các điều khoản này, 
              vui lòng không sử dụng dịch vụ của chúng tôi.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Định nghĩa</h2>
            <ul>
              <li><strong>"Dịch vụ"</strong> có nghĩa là nền tảng FConnect, bao gồm website, ứng dụng di động và tất cả các dịch vụ liên quan</li>
              <li><strong>"Người dùng"</strong> có nghĩa là bất kỳ cá nhân hoặc tổ chức nào sử dụng dịch vụ của chúng tôi</li>
              <li><strong>"Nhà cung cấp"</strong> có nghĩa là các cá nhân hoặc doanh nghiệp cung cấp dịch vụ thông qua nền tảng</li>
              <li><strong>"Khách hàng"</strong> có nghĩa là người dùng đặt và thanh toán cho các dịch vụ</li>
              <li><strong>"Nội dung"</strong> có nghĩa là văn bản, hình ảnh, video, âm thanh và các tài liệu khác được chia sẻ trên nền tảng</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>3. Tài khoản người dùng</h2>
            <h3>3.1 Đăng ký tài khoản</h3>
            <ul>
              <li>Bạn phải cung cấp thông tin chính xác, đầy đủ và cập nhật khi đăng ký</li>
              <li>Bạn chịu trách nhiệm bảo mật thông tin đăng nhập của mình</li>
              <li>Bạn phải thông báo ngay cho chúng tôi nếu phát hiện việc sử dụng trái phép tài khoản</li>
              <li>Mỗi người chỉ được tạo một tài khoản trên hệ thống</li>
            </ul>

            <h3>3.2 Yêu cầu về tuổi</h3>
            <p>
              Bạn phải từ 18 tuổi trở lên để sử dụng dịch vụ. Nếu dưới 18 tuổi, 
              bạn cần có sự đồng ý và giám sát của cha mẹ hoặc người giám hộ hợp pháp.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. Sử dụng dịch vụ</h2>
            <h3>4.1 Quy tắc sử dụng</h3>
            <p>Khi sử dụng dịch vụ của chúng tôi, bạn cam kết:</p>
            <ul>
              <li>Tuân thủ tất cả các luật pháp và quy định hiện hành</li>
              <li>Không sử dụng dịch vụ cho mục đích bất hợp pháp hoặc gian lận</li>
              <li>Không làm gián đoạn hoặc phá hoại hoạt động của hệ thống</li>
              <li>Không tạo ra hoặc truyền bất kỳ nội dung có hại, spam hoặc độc hại</li>
              <li>Tôn trọng quyền riêng tư và sở hữu trí tuệ của người khác</li>
            </ul>

            <h3>4.2 Hành vi bị cấm</h3>
            <p>Các hành vi sau đây bị nghiêm cấm:</p>
            <ul>
              <li>Sử dụng thông tin sai lệch hoặc mạo danh người khác</li>
              <li>Đăng tải nội dung khiêu dâm, bạo lực hoặc bất hợp pháp</li>
              <li>Quấy rối, đe dọa hoặc xúc phạm người dùng khác</li>
              <li>Thao túng đánh giá hoặc xếp hạng</li>
              <li>Sử dụng bot, script hoặc công cụ tự động không được phép</li>
              <li>Thu thập thông tin cá nhân của người dùng khác</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. Dịch vụ và Thanh toán</h2>
            <h3>5.1 Đặt dịch vụ</h3>
            <ul>
              <li>Khách hàng có thể đặt dịch vụ thông qua nền tảng của chúng tôi</li>
              <li>Mọi đơn đặt dịch vụ đều phải được xác nhận bởi nhà cung cấp</li>
              <li>Giá cả và điều kiện dịch vụ do nhà cung cấp quyết định</li>
              <li>Chúng tôi không chịu trách nhiệm về chất lượng dịch vụ được cung cấp</li>
            </ul>

            <h3>5.2 Thanh toán</h3>
            <ul>
              <li>Thanh toán được thực hiện thông qua các phương thức được chấp nhận trên nền tảng</li>
              <li>Chúng tôi có thể thu phí dịch vụ và hoa hồng theo quy định</li>
              <li>Tất cả các khoản phí đã thanh toán không được hoàn lại, trừ khi có quy định khác</li>
              <li>Bạn chịu trách nhiệm về tất cả các khoản phí phát sinh từ việc sử dụng tài khoản</li>
            </ul>

            <h3>5.3 Hủy và hoàn tiền</h3>
            <ul>
              <li>Chính sách hủy và hoàn tiền do từng nhà cung cấp quyết định</li>
              <li>Trong trường hợp tranh chấp, chúng tôi sẽ hỗ trợ giải quyết theo quy định</li>
              <li>Hoàn tiền (nếu có) sẽ được xử lý trong vòng 7-14 ngày làm việc</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>6. Nội dung và Sở hữu trí tuệ</h2>
            <h3>6.1 Nội dung của bạn</h3>
            <ul>
              <li>Bạn giữ quyền sở hữu đối với nội dung mà bạn tạo ra và chia sẻ</li>
              <li>Bằng việc đăng tải, bạn cấp cho chúng tôi quyền sử dụng nội dung để vận hành dịch vụ</li>
              <li>Bạn chịu trách nhiệm về tính chính xác và hợp pháp của nội dung</li>
              <li>Chúng tôi có quyền gỡ bỏ nội dung vi phạm điều khoản sử dụng</li>
            </ul>

            <h3>6.2 Nội dung của chúng tôi</h3>
            <ul>
              <li>Tất cả nội dung trên nền tảng (trừ nội dung do người dùng tạo) thuộc sở hữu của chúng tôi</li>
              <li>Bạn không được sao chép, phân phối hoặc sử dụng nội dung này mà không có sự cho phép</li>
              <li>Logo, thương hiệu và tên FConnect là tài sản trí tuệ của chúng tôi</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>7. Quyền riêng tư</h2>
            <p>
              Việc thu thập, sử dụng và bảo vệ thông tin cá nhân của bạn được quy định trong 
              <a href="/privacy" target="_blank" rel="noopener noreferrer"> Chính sách Bảo mật</a> của chúng tôi. 
              Bằng việc sử dụng dịch vụ, bạn đồng ý với các điều khoản trong chính sách đó.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Trách nhiệm và Giới hạn</h2>
            <h3>8.1 Tuyên bố từ chối trách nhiệm</h3>
            <ul>
              <li>Dịch vụ được cung cấp "như hiện tại" mà không có bảo đảm nào</li>
              <li>Chúng tôi không đảm bảo dịch vụ sẽ luôn khả dụng, an toàn hoặc không có lỗi</li>
              <li>Chúng tôi không chịu trách nhiệm về hành vi hoặc nội dung của người dùng khác</li>
              <li>Chúng tôi không đảm bảo chất lượng dịch vụ được cung cấp bởi nhà cung cấp</li>
            </ul>

            <h3>8.2 Giới hạn trách nhiệm</h3>
            <ul>
              <li>Chúng tôi không chịu trách nhiệm về thiệt hại gián tiếp, ngẫu nhiên hoặc mang tính hậu quả</li>
              <li>Tổng trách nhiệm của chúng tôi không vượt quá số tiền bạn đã trả trong 12 tháng qua</li>
              <li>Một số khu vực pháp lý không cho phép giới hạn trách nhiệm, do đó các giới hạn này có thể không áp dụng</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>9. Chấm dứt dịch vụ</h2>
            <h3>9.1 Chấm dứt bởi bạn</h3>
            <p>Bạn có thể ngừng sử dụng dịch vụ và xóa tài khoản bất cứ lúc nào thông qua cài đặt tài khoản.</p>

            <h3>9.2 Chấm dứt bởi chúng tôi</h3>
            <p>Chúng tôi có quyền tạm ngưng hoặc chấm dứt tài khoản của bạn nếu:</p>
            <ul>
              <li>Bạn vi phạm các điều khoản sử dụng</li>
              <li>Chúng tôi nghi ngờ hoạt động gian lận hoặc bất hợp pháp</li>
              <li>Theo yêu cầu của cơ quan pháp luật</li>
              <li>Vì lý do kinh doanh hoặc kỹ thuật</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>10. Giải quyết tranh chấp</h2>
            <h3>10.1 Thương lượng</h3>
            <p>
              Chúng tôi khuyến khích giải quyết tranh chấp thông qua thương lượng trực tiếp trước khi 
              sử dụng các biện pháp pháp lý.
            </p>

            <h3>10.2 Trọng tài</h3>
            <p>
              Nếu không thể giải quyết thông qua thương lượng, tranh chấp sẽ được giải quyết 
              thông qua trọng tài theo quy định của pháp luật Việt Nam.
            </p>

            <h3>10.3 Luật áp dụng</h3>
            <p>
              Các điều khoản này được điều chỉnh bởi luật pháp Việt Nam và bạn đồng ý tuân thủ 
              thẩm quyền của tòa án Việt Nam.
            </p>
          </section>

          <section className="terms-section">
            <h2>11. Thay đổi Điều khoản</h2>
            <p>
              Chúng tôi có thể cập nhật các điều khoản này theo thời gian. Khi có thay đổi quan trọng, 
              chúng tôi sẽ thông báo cho bạn qua email hoặc thông báo trên nền tảng. 
              Việc tiếp tục sử dụng dịch vụ sau khi thay đổi có nghĩa là bạn chấp nhận các điều khoản mới.
            </p>
          </section>

          <section className="terms-section">
            <h2>12. Điều khoản chung</h2>
            <ul>
              <li><strong>Tính độc lập:</strong> Nếu một phần của điều khoản bị vô hiệu, các phần còn lại vẫn có hiệu lực</li>
              <li><strong>Không từ bỏ quyền:</strong> Việc không thực thi một điều khoản không có nghĩa là từ bỏ quyền đó</li>
              <li><strong>Chuyển giao:</strong> Bạn không được chuyển giao quyền và nghĩa vụ mà không có sự đồng ý của chúng tôi</li>
              <li><strong>Toàn bộ thỏa thuận:</strong> Điều khoản này cùng với Chính sách Bảo mật tạo thành toàn bộ thỏa thuận</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>13. Liên hệ</h2>
            <p>
              Nếu bạn có bất kỳ câu hỏi nào về điều khoản sử dụng này, 
              vui lòng liên hệ với chúng tôi:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> trile@taichinh-htp.com</p>
              <p><strong>Điện thoại:</strong> 02513684266</p>
              <p><strong>Địa chỉ:</strong> 11/4C, tổ 15, Kp 6, Phường Trấn Biên, Tỉnh Đồng Nai, Việt Nam</p>
              <p><strong>Thời gian hỗ trợ:</strong> 8:00 - 22:00 (Thứ 2 - Chủ nhật)</p>
            </div>
          </section>
        </div>
      </section>

      {/* Footer (reuse from Home) */}
      <footer className="home-footer">
        <div className="home-container footer-inner">
          <div className="footer-contact">
            <p><strong>CÔNG TY CỔ PHẦN TÀI CHÍNH HIỆP TÍN PHÁT</strong></p>
            <p><strong>Email:</strong> trile@taichinh-htp.com</p>
            <p><strong>Điện thoại:</strong> 02513684266</p>
            <p><strong>Địa chỉ:</strong> 11/4C, tổ 15, Kp 6, Phường Trấn Biên, Tỉnh Đồng Nai, Việt Nam</p>
            <p><strong>Thời gian hỗ trợ:</strong> 8:00 - 22:00 (Thứ 2 - Chủ nhật)</p>
          </div>
          <div className="footer-stores">
            <a className="store-badge small appstore-badge" href="https://apps.apple.com/vn/app/fconnect-htp/id6752923786?l=vi" target="_blank" rel="noopener noreferrer">
              <span className="badge-icon" aria-hidden="true"></span>
              <span className="badge-text"><span className="badge-sub">Download on the</span><span className="badge-brand">App Store</span></span>
            </a>
            <a className="store-badge small play-badge" href="https://play.google.com/store/apps/details?id=com.taichinhhtp.fconnect&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
              <span className="badge-icon" aria-hidden="true">▶</span>
              <span className="badge-text"><span className="badge-sub">GET IT ON</span><span className="badge-brand">Google Play</span></span>
            </a>
          </div>
        </div>
        <div className="copyright">© 2025 Fconnect. Tất cả các quyền được bảo lưu.</div>
      </footer>
    </div>
  );
};

export default Terms; 